import { useContext, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom';

import DashboardContext from '../../Context';

import { getUpdate, postCreate, PutUpdate } from '../Data'

/**
 * این کامپوننت مرتبه بالای فرم های صفحات سایت است.
 * 
 */
const hocFrom = (WrappedComponent) => {

    const HocFrom = props => {
        const { location } = useHistory()
        const { authentication, urldashboard, handelAdd, edit, handelloding, handelEdit, loding, handeldmicro, handelerrors } = useContext(DashboardContext);

        const [LoadingForm, setLoadingForm] = useState(false);

        const [dataUpdate, setDataUpdate] = useState({})

        const [formdata, setFormdata] = useState({ isActive: false });

        const handelsetdataForm = (object) => setFormdata(object)

        const handelLoadingform = (item) => setLoadingForm(item)

        const handelSend = async () => {
            await postCreate(`${urldashboard}${props.urlWebsilte ? props.urlWebsilte : location.pathname}/create`, authentication, formdata, handelLoadingform, handelAdd, handeldmicro, handelerrors)
        }

        // برای پست آنی کامند بدون ست کردن ذیتای اضافه
        const handleSendWithSimCommand = async (command) => {
            await postCreate(`${urldashboard}${props.urlWebsilte ? props.urlWebsilte : location.pathname}/create`, authentication, command, handelLoadingform, handelAdd, handeldmicro, handelerrors)
        }

        const handelDataUpdate = (data) => {
            setDataUpdate(data)
            setFormdata(data)
        }

        const dataFeching = async () => {
            await getUpdate(`${urldashboard}${props.urlWebsilte ? props.urlWebsilte : location.pathname}/update/${edit}`, authentication, handelloding, handelAdd, handelEdit, handelDataUpdate, handeldmicro, handelerrors)
        }

        useEffect(() => {
            if (edit) {
                dataFeching()
            }
        }, []);

        const handelUpdataFrom = async () => {
            await PutUpdate(`${urldashboard}${props.urlWebsilte ? props.urlWebsilte : location.pathname}/update`, formdata, authentication, handelLoadingform, handelEdit, handelAdd, handeldmicro, handelerrors)
        }

        // برای پوت آنی کامند بدون ست کردن ذیتای اضافه
        const handleUpdateWithSimCommand = async (command) => {
            await PutUpdate(`${urldashboard}${props.urlWebsilte ? props.urlWebsilte : location.pathname}/update`, command, authentication, handelLoadingform, handelEdit, handelAdd, handeldmicro, handelerrors)
        }

        return <WrappedComponent {...props} handelUpdataFrom={handelUpdataFrom}
            handelSend={handelSend}
            handleSendWithSimCommand={handleSendWithSimCommand}
            handleUpdateWithSimCommand={handleUpdateWithSimCommand}
            loding={loding}
            handelLoadingform={handelLoadingform}
            LoadingForm={LoadingForm}
            handelsetdataForm={handelsetdataForm}
            dataUpdate={dataUpdate}
            formdata={formdata}
            setDataUpdate={setDataUpdate}
        />
    }

    return HocFrom
}
export default hocFrom

